import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from 'reactstrap';

import Grid from '../../components/cms/grid';
import AddNewButton from '../../components/cms/grid/addNewButton';
import ModelService from '../../services/language.service';

const initCriteria = {
  id: '',
  name: '',
  is_default: '',
  status: '',
  admin_status: '',
  title: '',
  priority: '',
  sortBy: 'priority',
  order: 'asc',
};

const Languages = ({ t, getColumns }) => (
  <div className="">
    <Row>
      <Col xl={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-language" /> {t('Languages')}</strong>
          </CardHeader>
          <CardBody>
            <div className="pull-right mb-1">
              <AddNewButton
                to={ModelService.getCreateUrl()}
                permissionToCreate={ModelService.getCreatePermissions()}
              />
            </div>
            <Grid
              id="languages"
              service={ModelService}
              columns={getColumns(t)}
              initCriteria={initCriteria}
              saveFilter={false}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Languages.propTypes = {
  t: PropTypes.func.isRequired,
  getColumns: PropTypes.func.isRequired,
};

export default Languages;



// WEBPACK FOOTER //
// ./src/views/languages/Languages.jsx